import { render, staticRenderFns } from "./IndexMain.vue?vue&type=template&id=55e6e9c6&scoped=true&"
import script from "./IndexMain.vue?vue&type=script&lang=js&"
export * from "./IndexMain.vue?vue&type=script&lang=js&"
import style0 from "./IndexMain.vue?vue&type=style&index=0&id=55e6e9c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6e9c6",
  null
  
)

export default component.exports